// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"38efeb2d","491":"edeb49a4","858":"8a83ca1b"}[chunkId] + ".chunk.css";
};